import React, { ReactNode } from 'react';

type Props = {
  title: ReactNode;
  children?: ReactNode;
};

function PageHeader({ title, children }: Props) {
  return (
    <div className='StaticPageHeader'>
      <h1 className='StaticPageHeader__title'>{title}</h1>
      {children}
    </div>
  );
}

export default PageHeader;
